import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const ADD_PRODUCT_TYPE = SERVER_URI + '/product-type';
const BIND_PRODUCT_TYPE = SERVER_URI + '/get-product-type';
const UPDATE_STATUS = SERVER_URI + '/product-type-status/'
const UPDATE_PAYMENT_TYPE = SERVER_URI + '/product-type/'

export default {

    addProductTYpe:async function(paylaod){
    
      return apiPost(ADD_PRODUCT_TYPE,paylaod)
    },

    Get_Product_Type: async function (paylaod) {
      console.log('payload',paylaod)
        return apiPost(BIND_PRODUCT_TYPE, paylaod)
    },
    changeProductStatus: async function (id) {
      return apiGet(UPDATE_STATUS + id)
  },
  updateProductType: async function (id, payload) {
    return apiPut(UPDATE_PAYMENT_TYPE + id, payload)
}

};